import {Screen} from '#component/base';
import {
  AccordionSection,
  Hero,
  InfoHeader,
  InternalNavBar,
  ReferenceSection,
} from '#component/partial';
import {InfoCTA} from '#component/partial/InfoCTA';
import {sprinkles} from '#style/sprinkles';

import {factors, infoCTAData, links, references, textData} from './SurprisedByYourResults.util';

export const SurprisedByYourAge = () => (
  <Screen pageName="Suprised By Your Results" withDefaultSizing={false} hideHeader>
    <InternalNavBar links={links} />

    <Hero variant="ecruWhite" id="overview" showScrollIndicator>
      <InfoHeader {...textData} />
    </Hero>

    <section className={sprinkles({pY: [48, 72, 144]})} id="factors">
      <AccordionSection {...factors} />
    </section>

    <section className={sprinkles({bg: 'ecruWhite', pY: [48, 72, 144]})} id="results">
      <InfoCTA {...infoCTAData} />
    </section>

    <section className={sprinkles({bg: 'springWood', pY: [48, 72, 144]})} id="references">
      <ReferenceSection references={references} />
    </section>
  </Screen>
);
